module.exports = __webpack_public_path__ + "img/product-3-50.png?373730331e906800c6855543f525a43f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/product-3-50.png
// module id = 418
// module chunks = 0